// @flow

import styled from 'styled-components';

export const Title = styled.h2`
  font-family: 'DanskeHuman-MediumItalic';
  font-size: 2.25rem;
  font-weight: 500;
  color: ${(props) => props.theme.textColor};
  line-height: 1.09;
  margin: 0;
`;

export const SmallTitle = styled.h3`
  font-family: 'DanskeHuman-MediumItalic';
  font-size: 1.375rem;
  font-weight: 500;
  color: ${(props) => props.theme.textColor};
  line-height: 1.91;
  margin: 0;
`;

export const Heading = styled.h5`
  font-size: 1rem;
  color: ${(props) => props.theme.textColor};
  margin: 0;
`;

export const Text = styled.span`
  color: ${(props) => props.theme.textColor};
`;

export const DimmedText = styled.span`
  color: ${(props) => props.theme.textSecondaryColor};
`;

export const SmallText = styled(Text)`
  font-size: 0.875rem;
  line-height: 1.29;
`;
SmallText.displayName = 'SmallText';

export const TinyText = styled(Text)`
  font-size: 0.75rem;
  line-height: 1.29;
`;
TinyText.displayName = 'TinyText';
